<template>
  <v-col>
    <label class="title-label">Sets</label>

    <v-data-table
      v-model="selected"
      :items="exerciseSet.set"
      dense
      :headers="computedHeaders"
      item-key="id"
      @click:row="handleClick"
      class="table-sets"
    >
      <template v-slot:[`item.fm`]="{ item }">
        {{ item.fm }} {{ units[exerciseSet.unitId] }}
      </template>

      <template v-slot:[`item.tpsDeTravail`]="{ item }">
        {{ item.tpsDeTravail | readableTime }}
      </template>

      <template v-slot:[`item.tpsDeRécup`]="{ item }">
        {{ item.tpsDeRécup | readableTime }}
      </template>
    </v-data-table>
  </v-col>
</template>

<script>
  export default {
    name: 'exercise-sets',
    
    props: {
      exerciseSet: Object,
    },

    data() {
      return {
        selected: [],
        units: {
          1: 'RM',
          2: '%',
          3: 'KGs',
          4: 'RPE',
          5: 'M',
        },
        headers: [
          { sortable: false, text: 'Série(s)', value: 'name' },
          { sortable: false, text: 'Répétition', value: 'rep', col: 'repetitionType' },
          { sortable: false, text: 'Charge', value: 'fm', col: 'forceType' },
          { sortable: false, text: 'Tps de travail', value: 'tpsDeTravail', col: 'effortType' },
          { sortable: false, text: 'distance', value: 'distance', col: 'distanceType' },
          { sortable: false, text: 'Fréq. cardiaque', value: 'fcm', col: 'hrateType' },
          { sortable: false, text: 'Tempo', value: 'tempo', col: 'tempo' },
          { sortable: false, text: 'Tps de récup.', value: 'tpsDeRécup', col: 'restType' },
          { sortable: false, text: 'Autre', value: 'autre', col: 'autre' },
        ],
      }
    },

    methods: {
      handleClick: function(item) {
        this.selected = [item];
      }
    },

    computed: {
      computedHeaders: function () {
        return this.headers.filter((header) => {
          if (header.col === "autre" || header.col === "tempo")
            return this.exerciseSet.set[0][header.col];
          else
            return !header.col || header.col && this.exerciseSet[header.col] !== null;
        });
      }
    },
  }
</script>

<style>
  .table-sets .v-data-table__selected {
    background: #666 !important;
    color: #FFF;
  }
</style>